<template>
    <BaseFilterSelect
        v-if="!pending && selectableChapters && currentChapter"
        id="guideline-chapters-select"
        v-model="currentChapter"
        :options="selectableChapters"
        :placeholder="placeholder"
        :track-by-property="'uri'"
        class="guideline-chapters-select filter-select--wrapped"
        @update:model-value="goToChapter($event)"
    />

    <content-placeholders
        v-else-if="pending"
        class="guideline-chapters-select"
    >
        <content-placeholders-text :lines="1" />
    </content-placeholders>
</template>

<script setup>
import {lowerCase, startCase} from 'lodash-es';

const props = defineProps({
    placeholder: {
        type: String,
        default: 'Select chapter',
        required: false
    },
    pending: {
        type: Boolean,
        default: false,
        required: false
    },
    numeric: {
        type: Boolean,
        default: true,
        required: false
    },
    chapters: {
        type: Array,
        required: false,
        default: () => []
    }
});

const currentChapter = ref(null);

const selectableChapters = computed(() => {
    if (!props.numeric) {
        return props.chapters;
    }
    return props.chapters
        ? props.chapters.map((chapter, index) => {
            return {
                title: `${index + 1}. ${startCase(lowerCase(chapter.title))}`,
                slug: chapter.slug,
                uri: chapter.uri
            };
        })
        : [];
});

const route = useRoute();

const setActiveChapter = () => {
    if (route.name === 'guideline-slug' || route.name === 'guideline-summary') {
        currentChapter.value = selectableChapters.value ? selectableChapters.value[0] : null;
    } else {
        currentChapter.value = selectableChapters.value ? selectableChapters.value.find(chapter => '/' + chapter.uri === route.path) : null;
    }
};

watch(() => route, () => {
    setActiveChapter();
}, {immediate: true, deep: true});

watch(selectableChapters, () => {
    setActiveChapter();
});

const router = useRouter();

const goToChapter = (chapterUri) => {
    router.push({path: `/${chapterUri}`});
};
</script>
